import { createContext as t } from "react";
var o = t({
  websiteType: "unknown",
  // Type of website to assume for relative links eg. 'marketing'
  Link: null,
  // Link component for relative links
  formatMessage: function formatMessage(_ref) {
    var e = _ref.id;
    return e;
  },
  // for translated strings
  navigate: null
  // for navigating to a page
});
export { o as WebsiteContext };